import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { SI_WIZARD_BACKGROUND_URL } from "app/pages/sales-intelligence/constants/images";

import {
    ONBOARDING_CONTENT_SIDE_PADDING,
    ONBOARDING_CONTENT_TOP_PADDING,
    ONBOARDING_FOOTER_HEIGHT,
    ONBOARDING_LEFT_PART_WIDTH,
    ONBOARDING_MIN_CONTENT_WRAPPER_WIDTH,
} from "../constants/sizes";

export const StyledOnboardingLeftPartWrapper = styled.div`
    width: ${ONBOARDING_LEFT_PART_WIDTH}px;
    min-width: ${ONBOARDING_LEFT_PART_WIDTH}px;
`;

export const StyledOnboardingContentWrapper = styled.div`
    width: calc(100% - ${ONBOARDING_LEFT_PART_WIDTH}px);
    overflow-x: auto;
`;

export const StyledOnboardingContentContainer = styled.div`
    position: relative;
    padding-top: ${ONBOARDING_CONTENT_TOP_PADDING}px;
    padding-bottom: ${ONBOARDING_CONTENT_SIDE_PADDING}px;
    height: calc(100% - ${ONBOARDING_CONTENT_TOP_PADDING + ONBOARDING_CONTENT_SIDE_PADDING}px);
`;

export const StyledFlexFormContentWrapper = styled(Flex)`
    padding: 0 ${ONBOARDING_CONTENT_SIDE_PADDING}px;
`;

export const StyledFlexFooterWrapper = styled(Flex)`
    padding: 16px ${ONBOARDING_CONTENT_SIDE_PADDING}px 0px ${ONBOARDING_CONTENT_SIDE_PADDING}px;
    max-height: ${ONBOARDING_FOOTER_HEIGHT}px;
`;

export const StyledOnboardingLeftPartContainer = styled.div`
    background-image: url(${SI_WIZARD_BACKGROUND_URL});
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100% - 64px);
    padding: 55px 32px 32px 32px;
`;

export const StyledWelcomeText = styled.div`
    ${setFontVariant("button", colorsPalettes.carbon[500])};
    font-weight: 400;
    display: flex;

    img {
        width: 21px;
        height: 21px;
        margin: 0 8px 0 6px;
    }
`;

export const StyledSITitleText = styled.span`
    ${setFontVariant("button", colorsPalettes.carbon[500])};
    font-weight: 400;
    font-style: normal;
    letter-spacing: -0.28px;
`;

export const StyledOnboardingGreetingText = styled.div`
    margin-top: 63px;
    margin-bottom: 24px;
    ${setFontVariant("h2", colorsPalettes.carbon[500])};
`;
export const StyledOnboardingDescription = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[400])};
`;

const StyledAnimationWrapper = styled.div`
    height: 100%;
    min-width: ${ONBOARDING_MIN_CONTENT_WRAPPER_WIDTH}px;

    &.item-exit {
        opacity: 1;
    }

    &.item-exit-active {
        opacity: 0;
        transition: opacity 500ms ease-out;
    }
`;
export const StyledAnimatedDescription = styled(StyledAnimationWrapper)`
    height: auto;
    min-width: unset;

    &.item-enter {
        opacity: 0;
    }

    &.item-enter-active {
        opacity: 1;
        transition: opacity 500ms ease-out;
    }
`;

export const StyledOnboardingContentSubSection = styled(Flex)`
    flex-direction: column;
    gap: 8px;
`;

export const StyledExtensionDemoImage = styled.img`
    min-width: 282px;
`;

export const StyledExtensionBlock = styled(FlexColumn)`
    gap: 24px;
    justify-content: center;
`;
